// Copyright ©️ 2026 eVolve MEP, LLC

import { SizeField } from './SizeField';

type StampSizeFieldProps = { id: string; label: string; value: string };

export const StampSizeField = (props: StampSizeFieldProps) => <SizeField {...props} />;
